/* MELYR: on desktop, show the fit notes and mauve trust box under the product photos instead of in the right column */
(function(){
  function ensure(){
    var product=document.querySelector('.product');
    if(!product) return;
    var info=product.querySelector('.product-info');
    if(!info) return;
    var trust=info.querySelector('.m-pdp-trust2');
    if(!trust) return;
    var gallery=product.querySelector(':scope > product-gallery');
    if(!gallery) return;
    var slot=product.querySelector(':scope > .m-trust-slot');
    var fit=info.querySelector('.m-pdp-fit');
    var human=info.querySelector('.m-pdp-human');
    var html=(fit?fit.outerHTML:'')+trust.outerHTML+(human?human.outerHTML:'');
    if(!slot){
      slot=document.createElement('div');
      slot.className='m-trust-slot';
      gallery.insertAdjacentElement('afterend',slot);
    }
    if(slot.innerHTML!==html) slot.innerHTML=html;
    product.classList.add('m-has-trust-slot');
  }
  var t;
  function soon(){clearTimeout(t);t=setTimeout(ensure,50);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ensure); else ensure();
  new MutationObserver(function(ms){
    for(var i=0;i<ms.length;i++){if(!ms[i].target.closest||!ms[i].target.closest('.m-trust-slot')){soon();return;}}
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
